/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import gql from 'graphql-tag';
import {
  getAttributeFragment,
  getCustomAttributeFragment,
  constructAttributeUpdateVariables,
  constructCustomAttributeUpdateVariables,
} from '@/graphql/listing/AttributesQueryConfig';
import {
  getCustomAttributeGqlTypeName,
  customAttributeTypeToFieldType,
} from '@/graphql/utils/custom_attributes/typeNames';

// TODO: add attr type
export default (type: string, id: string, attr: any, val: any) => {
  let fragment;
  let input;
  let argsDefinition = `$attr_input: Update${type}Input!`;
  let variables = {};

  if (attr.isCustomAttribute) {
    const caTypeName = getCustomAttributeGqlTypeName(attr.customAttributeType, attr.name);
    const fieldType = customAttributeTypeToFieldType[attr.customAttributeType];
    fragment = getCustomAttributeFragment(attr.name, caTypeName);
    argsDefinition = `$ca_input: [CustomAttributeInput]`;
    input = `input: {}, customAttributes: $ca_input`;

    // Empty value needs to be passed as `null`
    if (val === '') {
      val = null;
    }

    variables = constructCustomAttributeUpdateVariables(attr, fieldType, val);
  } else {
    fragment = getAttributeFragment(type, attr.name);
    input = `input: $attr_input`;
    variables = constructAttributeUpdateVariables(attr, val);
  }

  const mutation = gql`
    mutation AttributeMutation(${argsDefinition}) {
      update${type}(id: "${id}", ${input}) {
        result {
          id
          ${fragment}
        }
      }
    }
  `;

  return {
    mutation: mutation,
    variables: variables,
  };
};
